import { CircularProgress, Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import styled from 'styled-components';

import useSurfaceReports from 'core/hooks/useSurfaceReports';
import { FormSubmitHandler } from 'Elements/Form';

import FilterSurfaceReport from './FilterSurfaceReport';
import { Schema } from './schema';
import SurfaceReportGraph from './SurfaceReportGraph';
import SurfaceReportTable from './SurfaceReportTable';

const Height100 = styled.div`
  height: 100%;
`;
const Width100 = styled.div`
  width: 100%;
  max-width: 250px;
`;

const Overflow = styled.div`
  position: relative;
  /* always visible scrollbar so the graph can calucalte itself */
  overflow-y: scroll;
`;

const Absolute = styled.div`
  position: absolute;
`;

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

const NoResults = styled.div`
  text-align: center;
  padding: 50px;
`;

export default function SurfaceReport() {
  const [params, setParams] = useState({});
  const { reports, loading } = useSurfaceReports(params);

  const onSubmit: FormSubmitHandler<Schema> = (values) => setParams(values);

  return (
    <Grid container direction="row" component={Height100}>
      <Grid item xs component={Width100}>
        <FilterSurfaceReport onSubmit={onSubmit} />
      </Grid>

      <Grid item sm={12} md={8} component={Overflow}>
        {loading && (
          <Centered>
            <CircularProgress />
          </Centered>
        )}
        {!loading && reports.data && reports.data.length !== 0 && (
          <Grid container direction="column" component={Absolute}>
            <Grid item>
              <Typography align="center">
                Mediaani urasyyvyden kuluma (pienempi luku on parempi)
              </Typography>
            </Grid>
            <Grid item>
              <SurfaceReportGraph data={reports.meta} />
            </Grid>
            <Grid item xs>
              <SurfaceReportTable data={reports.data} />
            </Grid>
          </Grid>
        )}
        {!loading && reports.data && reports.data.length === 0 && (
          <Grid container direction="column">
            <Grid item>
              <NoResults>
                <Typography variant="h3">Ei tuloksia</Typography>
                <Typography variant="body1">
                  Koita uudestaan eri suodattimilla
                </Typography>
              </NoResults>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
}
